import React, { useContext } from 'react'
import { Route, Routes } from 'react-router-dom'

import NotFound from '../../../NotFound'

import { AbilityContext } from '../../../../components/Ability'
import GeneralListPage from './Features/GeneralList'


const GeneralPage = () => {
  const ability = useContext(AbilityContext)
  return (
    <Routes>
      <Route
        path="/"
        element={
          ability.can('read', 'setting') ? < GeneralListPage /> : <NotFound />
        }
      />
    </Routes>
  )
}

export default GeneralPage
